
import { defineComponent, PropType } from 'vue';
import { FollowNotificationDto } from "@/api/models/notification.dtos";

export default defineComponent({
  name: 'FollowNotificationItem',
  props: {
    notification: Object as PropType<FollowNotificationDto>,
  },
  computed: {
    longCreateAt() {
      if (!this.notification?.createdAt) {
        return null;
      }
      const date = new Date(this.notification.createdAt);
      const hours = `${date.getHours()}`.padStart(2, '0');
      const minutes = `${date.getMinutes()}`.padStart(2, '0');
      return `${date.getFullYear()}. ${date.getMonth() + 1}. ${date.getDate()}. ${hours}:${minutes}`;
    },
    followerUrl() {
      const blogId = this.notification?.follower?.blogId;
      if (!blogId) {
        return null;
      }
      return `/${blogId}`;
    },
  },
  methods: {},
});
